"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_PAGINATED_RESPONSE = exports.DEFAULT_ITEMS_PER_PAGE = void 0;
var DEFAULT_ITEMS_PER_PAGE = 20;

// As prescribed by nestjs-typeorm-pagination plugin
exports.DEFAULT_ITEMS_PER_PAGE = DEFAULT_ITEMS_PER_PAGE;
var DEFAULT_PAGINATED_RESPONSE = {
  items: [],
  meta: {
    itemCount: 0,
    totalItems: 0,
    itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
    totalPages: 0,
    currentPage: 1
  }
};
exports.DEFAULT_PAGINATED_RESPONSE = DEFAULT_PAGINATED_RESPONSE;